export * from "./content-quality.js";
export * from "./channel-safety.js";
export const tenantRoles = [
    "tenant_owner",
    "tenant_admin",
    "content_editor",
    "approver",
    "viewer",
];
export const permissions = [
    "tenant.read",
    "tenant.manage",
    "brand.read",
    "brand.manage",
    "team.read",
    "team.manage",
    "audit.read",
    "content.read",
    "content.manage",
    "content.approve",
    "ai.generate",
    "ai.manage",
    "ai.usage.read",
    "research.read",
    "research.manage",
    "research.run",
    "research.convert",
    "channel.read",
    "channel.manage",
    "channel.command",
    "channel.approve",
    "channel.moderate",
    "publication.read",
    "publication.manage",
    "publication.publish",
];
export const contentBriefStatuses = [
    "draft",
    "in_review",
    "changes_requested",
    "approved",
    "scheduled",
    "cancelled",
];
export const contentBriefTransitions = {
    draft: ["in_review"],
    in_review: ["approved", "changes_requested"],
    changes_requested: ["in_review"],
    approved: ["scheduled"],
    scheduled: ["approved"],
    cancelled: [],
};
export const contentScheduleStatuses = [
    "scheduled",
    "queued",
    "ready_for_publication",
    "cancelled",
    "failed",
];
export function detectImageMime(bytes) {
    if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
        return "image/jpeg";
    }
    if (bytes.length >= 8
        && bytes.subarray(0, 8).equals(Buffer.from([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]))) {
        return "image/png";
    }
    if (bytes.length >= 12
        && bytes.toString("ascii", 0, 4) === "RIFF"
        && bytes.toString("ascii", 8, 12) === "WEBP") {
        return "image/webp";
    }
    return null;
}
export function detectVideoMime(bytes) {
    if (bytes.length >= 12
        && bytes.toString("ascii", 4, 8) === "ftyp") {
        return "video/mp4";
    }
    return null;
}
const rolePermissions = {
    tenant_owner: new Set(permissions),
    tenant_admin: new Set([
        "tenant.read",
        "tenant.manage",
        "brand.read",
        "brand.manage",
        "team.read",
        "team.manage",
        "audit.read",
        "content.read",
        "content.manage",
        "content.approve",
        "ai.generate",
        "ai.manage",
        "ai.usage.read",
        "research.read",
        "research.manage",
        "research.run",
        "research.convert",
        "channel.read",
        "channel.manage",
        "channel.command",
        "channel.approve",
        "channel.moderate",
        "publication.read",
        "publication.manage",
        "publication.publish",
    ]),
    content_editor: new Set([
        "tenant.read",
        "brand.read",
        "team.read",
        "content.read",
        "content.manage",
        "ai.generate",
        "research.read",
        "research.run",
        "research.convert",
        "channel.read",
        "channel.command",
        "publication.read",
    ]),
    approver: new Set([
        "tenant.read",
        "brand.read",
        "team.read",
        "audit.read",
        "content.read",
        "content.approve",
        "ai.usage.read",
        "research.read",
        "channel.read",
        "channel.approve",
        "publication.read",
        "publication.publish",
    ]),
    viewer: new Set([
        "tenant.read",
        "brand.read",
        "team.read",
        "audit.read",
        "content.read",
        "ai.usage.read",
        "research.read",
        "publication.read",
    ]),
};
export function hasPermission(roles, permission) {
    return roles.some((role) => {
        if (!isTenantRole(role))
            return false;
        return rolePermissions[role].has(permission);
    });
}
export function isTenantRole(value) {
    return tenantRoles.includes(value);
}
export class DomainError extends Error {
    code;
    statusCode;
    details;
    constructor(code, message, statusCode, details) {
        super(message);
        this.code = code;
        this.statusCode = statusCode;
        this.details = details;
        this.name = "DomainError";
    }
}
export function assertTransition(current, next, allowed) {
    if (!(allowed[current] ?? []).includes(next)) {
        throw new DomainError("INVALID_STATE_TRANSITION", `Cannot transition from ${current} to ${next}`, 409, { current, next });
    }
}
export function assertContentBriefTransition(current, next) {
    assertTransition(current, next, contentBriefTransitions);
}
//# sourceMappingURL=index.js.map